var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g2, _g3, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 35 20)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 40,
    viewBox: "0 0 40 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_26643_10012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0723 67.3076C12.6834 67.3076 5.07227 59.6965 5.07227 50.3076L5.07227 10.6922C5.07227 6.27396 8.65399 2.69223 13.0723 2.69223L29.6437 2.69223C34.062 2.69223 37.6437 6.27395 37.6437 10.6922L37.6437 52.3076C37.6437 60.5919 30.928 67.3076 22.6437 67.3076L22.0723 67.3076Z",
    fill: "#B6B9BE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4396 34.6071C34.6429 18.9712 34.775 9.45397 33.6975 6.15784C33.4637 5.44001 32.8233 4.8638 31.9441 4.3999C31.7611 4.57081 31.4917 4.69777 31.1004 4.69777C29.84 4.69777 29.225 3.9067 27.8324 4.13621C26.8566 4.29247 26.5669 3.46233 26.4754 2.9496C25.8604 2.86659 25.2505 2.80311 24.661 2.75428C24.5339 2.92519 24.3204 3.04238 24.0866 3.04238L15.9192 3.04238C15.6803 3.04238 15.4719 2.93007 15.3449 2.75916C14.5571 2.82752 13.7287 2.9203 12.9053 3.04238C12.7986 3.55511 12.4885 4.28759 11.5686 4.13621C10.176 3.91158 9.56107 4.69777 8.30062 4.69777C8.077 4.69777 7.88895 4.65382 7.74156 4.58546C7.0351 5.01518 6.52177 5.52791 6.31848 6.15296C5.241 9.44909 5.37315 18.9664 5.57644 34.6022C5.61202 37.5321 4.07205 49.4324 4.9818 57.0062C5.32741 59.8677 5.87631 61.3473 6.85722 62.5388C7.26381 62.4558 7.7009 62.529 8.06684 62.7878L11.5991 65.2733C11.9701 65.537 12.1938 65.9326 12.2497 66.3476C12.4174 66.4062 12.5902 66.46 12.763 66.5088V63.3592L27.253 63.3592V66.5088C27.4258 66.4551 27.5986 66.4014 27.7663 66.3476C27.8222 65.9277 28.0459 65.5322 28.4169 65.2733L31.9492 62.7878C32.3151 62.529 32.7522 62.4558 33.1588 62.5388C34.1397 61.3473 34.6886 59.8677 35.0342 57.0062C35.949 49.4324 34.404 37.5321 34.4396 34.6022V34.6071Z",
    fill: "url(#paint0_radial_26643_10012)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7619 63.3676L12.7619 66.5124C16.894 67.7478 23.1199 67.7478 27.252 66.5124V63.3627L12.7619 63.3627V63.3676Z",
    fill: "#6B6B6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5749 34.977C33.7629 19.9271 33.89 10.7663 32.8786 7.59225C31.7096 3.93476 20.0099 4.13498 20.0099 4.13498C20.0099 4.13498 8.3101 3.93476 7.14115 7.59225C6.12466 10.7663 6.25172 19.9271 6.44485 34.977C6.48043 37.7995 5.02685 49.2505 5.88579 56.541C6.44485 61.2923 7.57823 62.0883 10.3583 64.315C14.1295 67.3377 25.9004 67.3377 29.6715 64.315C32.4516 62.0883 33.585 61.2923 34.1441 56.541C35.003 49.2505 33.5494 37.7995 33.585 34.977H33.5749Z",
    fill: "url(#paint1_radial_26643_10012)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5242 39.9054C22.9423 40.2717 17.0772 40.2717 14.4953 39.9054C11.5018 39.4855 9.59078 38.5381 9.59078 38.5381L9.40273 39.5783C10.0533 39.8468 11.8016 40.4914 14.2514 40.8235C16.9501 41.1897 23.0795 41.1897 25.7783 40.8235C28.228 40.4914 29.9764 39.8468 30.627 39.5783L30.4389 38.5381C30.4389 38.5381 28.5228 39.4806 25.5344 39.9054H25.5242Z",
    fill: "#535353"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1931 48.2153V48.1811C32.0508 48.3227 31.7866 48.4692 31.3749 48.6401C30.4245 49.0357 28.7727 49.6949 26.1857 50.2369C22.4755 51.0134 17.5456 51.0134 13.8303 50.2369C11.2434 49.6949 9.59159 49.0357 8.64117 48.6401C8.22441 48.4692 7.96013 48.3227 7.82798 48.1811V48.2153C7.82798 48.2153 7.64502 48.9673 7.75683 49.1675C7.85339 49.3433 8.13801 49.5094 8.64117 49.7144C9.59159 50.11 11.2434 50.7692 13.8303 51.3112C17.5405 52.0877 22.4705 52.0877 26.1857 51.3112C28.7727 50.7692 30.4245 50.11 31.3749 49.7144C31.878 49.5045 32.1576 49.3433 32.2592 49.1675C32.371 48.9673 32.1982 48.2153 32.1982 48.2153H32.1931Z",
    fill: "#545454"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7676 40.8223C23.0688 41.1885 16.9394 41.1885 14.2407 40.8223C11.7909 40.4902 10.0426 39.8457 9.39203 39.5771L7.82156 48.1861C7.9537 48.3277 8.21799 48.4742 8.63475 48.6451C9.58516 49.0406 11.237 49.6999 13.8239 50.2419C17.5341 51.0183 22.464 51.0183 26.1793 50.2419C28.7662 49.6999 30.418 49.0406 31.3685 48.6451C31.7852 48.4742 32.0495 48.3277 32.1816 48.1861L30.6112 39.5771C29.9657 39.8457 28.2123 40.4902 25.7625 40.8223H25.7676Z",
    fill: "url(#paint2_linear_26643_10012)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2257 9.07268C30.2257 9.07268 28.147 8.17417 25.1737 7.65167C22.8866 7.24637 17.1333 7.24637 14.8462 7.65167C11.873 8.17417 9.7943 9.07268 9.7943 9.07268C9.7943 9.07268 9.42328 12.4518 10.1907 15.9921C10.267 16.3535 10.3585 16.7148 10.4652 17.0762C10.4652 17.0762 10.6126 17.0176 10.887 16.9248C12.0001 16.5439 15.2782 15.5868 20.0151 15.5868C25.1839 15.5868 28.1215 16.5048 29.1482 16.9004C29.4277 17.0078 29.565 17.0762 29.565 17.0762C29.6717 16.7051 29.7632 16.329 29.8445 15.9579C30.6018 12.4323 30.2358 9.07756 30.2358 9.07756L30.2257 9.07268ZM20.0049 14.7909C15.6798 14.7909 12.4372 15.4208 10.6888 15.8603C10.2212 12.7253 10.5008 9.97606 10.5008 9.97606C10.5008 9.97606 12.4372 9.07756 15.202 8.55506C17.3315 8.14976 22.6783 8.14976 24.8078 8.55506C27.5726 9.07756 29.509 9.97606 29.509 9.97606C29.509 9.97606 29.7886 12.696 29.3261 15.8114C27.6946 15.3768 24.6452 14.7909 20.0049 14.7909Z",
    fill: "url(#paint3_linear_26643_10012)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5101 9.97126C29.5101 9.97126 27.5737 9.07276 24.8089 8.55026C22.6794 8.14496 17.3326 8.14496 15.2031 8.55026C12.4383 9.07276 10.5019 9.97126 10.5019 9.97126C10.5019 9.97126 10.2223 12.7205 10.6899 15.8555C12.4332 15.416 15.6809 14.7861 20.006 14.7861C24.6513 14.7861 27.6957 15.372 29.3272 15.8066C29.7846 12.6912 29.5101 9.97126 29.5101 9.97126Z",
    fill: "#1E1E1E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28398 29.0391L7.22051 29.713C7.28659 30.4308 7.36282 31.8323 7.3679 33.9028C7.37299 36.0758 7.06804 39.4549 6.96131 41.9063C6.78851 45.7835 6.96131 48.4888 6.96131 48.4888L8.93329 37.946L9.28906 29.0489L9.28398 29.0391Z",
    fill: "#424242"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0509 41.9014C32.9442 39.45 32.6393 36.0758 32.6443 33.8979C32.6494 31.8323 32.7155 30.4113 32.7917 29.7081L30.7283 29.0343L31.084 37.9314L33.056 48.4741C33.056 48.4741 33.2288 45.7689 33.056 41.8916L33.0509 41.9014Z",
    fill: "#424242"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55307 18.1404C7.64332 16.4019 7.16049 15.9136 7.16049 15.9136C7.16049 15.9136 6.92669 26.1048 7.16049 28.8882L9.30019 28.0287L9.53906 20.5868C9.53906 20.5868 9.35101 19.6639 8.55307 18.1355V18.1404Z",
    fill: "#424242"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8531 15.9146C32.8531 15.9146 32.3703 16.4029 31.4605 18.1413C30.6626 19.6649 30.4745 20.5927 30.4745 20.5927L30.7134 28.0346L32.8531 28.894C33.0869 26.1058 32.8531 15.9195 32.8531 15.9195V15.9146Z",
    fill: "#424242"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5936 65.2768L8.0613 62.7913C7.69537 62.5324 7.25828 62.4592 6.85169 62.5422C7.55814 63.4016 8.49331 64.1146 9.73342 65.0863C10.3738 65.5893 11.2378 66.0093 12.2441 66.3511C12.1882 65.9311 11.9646 65.5356 11.5936 65.2768Z",
    fill: "url(#paint4_radial_26643_10012)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9486 62.7913L28.4163 65.2768C28.0453 65.5405 27.8217 65.936 27.7657 66.3511C28.7721 66.0093 29.6361 65.5893 30.2765 65.0863C31.5217 64.1146 32.4517 63.4016 33.1582 62.5422C32.7516 62.4592 32.3145 62.5324 31.9486 62.7913Z",
    fill: "url(#paint5_radial_26643_10012)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_26643_10012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.73469 4.58447C7.88716 4.65283 8.07013 4.69678 8.29376 4.69678C9.5542 4.69678 10.1641 3.90571 11.5618 4.13522C12.4817 4.2866 12.7917 3.55412 12.8984 3.04139C10.9468 3.33438 9.01546 3.81781 7.73469 4.58935V4.58447Z",
    fill: "#C71F1F"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_26643_10012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8317 4.13619C29.2243 3.91157 29.8392 4.69775 31.0997 4.69775C31.491 4.69775 31.7604 4.57079 31.9434 4.39988C30.5254 3.65764 28.4771 3.21327 26.4747 2.94958C26.5611 3.46231 26.8558 4.29245 27.8317 4.13619Z",
    fill: "#C71F1F"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8995 57.6447C12.5742 56.0869 10.1855 51.8972 10.1855 51.8972C10.1855 51.8972 11.8983 56.3262 12.2439 57.8693C12.498 59.0071 12.7572 62.5083 12.7572 62.5083C12.7572 62.5083 13.1485 58.8362 12.8995 57.6447Z",
    fill: "#545454"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8535 51.8972C29.8535 51.8972 27.4648 56.0869 27.1395 57.6447C26.8905 58.8362 27.2818 62.5083 27.2818 62.5083C27.2818 62.5083 27.541 59.0071 27.7951 57.8693C28.1407 56.3262 29.8535 51.8972 29.8535 51.8972Z",
    fill: "#545454"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.255 16.7692H18.7545C15.7253 16.984 10.958 17.5114 10.5667 18.698C9.98726 20.4462 9.89578 38.0646 9.89578 38.0646C9.89578 38.0646 12.437 39.3879 19.9996 39.2219C27.5674 39.3879 30.1035 38.0646 30.1035 38.0646C30.1035 38.0646 30.012 20.4462 29.4326 18.698C29.0413 17.5114 24.274 16.984 21.2448 16.7692H21.255Z",
    fill: "url(#paint6_linear_26643_10012)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3258 4.71652C20.9446 4.70187 20.5075 4.69698 20.0094 4.69698C20.0094 4.69698 19.0743 4.70675 18.6931 4.71652C11.3439 4.93626 8.09114 6.93835 8.09114 6.93835L9.54472 8.62305C14.1342 6.15705 20.0094 6.66001 20.0094 6.66001C20.0094 6.66001 25.8898 6.15705 30.4742 8.62305L31.9277 6.93835C31.9277 6.93835 28.675 4.93626 21.3258 4.71652Z",
    fill: "#C71F1F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12428 50.0429C6.12428 50.0429 6.05313 52.5724 6.54612 57.5923C7.02895 62.5047 11.5879 64.7168 11.5879 64.7168C7.68459 62.0506 6.12428 50.0478 6.12428 50.0478V50.0429Z",
    fill: "#676767"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9144 50.0419C33.9144 50.0419 32.3541 62.0496 28.4508 64.7109C28.4508 64.7109 33.0046 62.4989 33.4926 57.5864C33.9856 52.5665 33.9144 50.037 33.9144 50.037V50.0419Z",
    fill: "#676767"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9658 44.9358C32.9404 46.1859 32.859 47.4555 32.9658 47.8267C32.9658 47.8267 34.1449 47.602 34.1754 46.6303C34.2008 45.6585 32.9963 43.6857 32.9658 44.9358Z",
    fill: "#1C1C1C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1633 45.1547L33.753 46.1509C33.8089 46.4878 33.9664 46.8931 34.4391 46.7418C34.4391 46.7418 36.8177 46.0337 37.0769 45.6968C37.2192 45.5161 37.2039 45.3061 37.1633 45.1547Z",
    fill: "url(#paint7_linear_26643_10012)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7233 45.7363C33.7233 45.7363 33.7131 45.9316 33.7487 46.1514L37.1641 45.1552C37.1285 45.0282 37.0777 44.9355 37.0777 44.9355L33.7283 45.7363H33.7233Z",
    fill: "#1C1C1C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03461 45.0027C7.00411 43.7575 5.71826 45.7254 5.74875 46.6972C5.77925 47.6689 7.03461 47.8936 7.03461 47.8936C7.14642 47.5176 7.0651 46.2479 7.03461 45.0027Z",
    fill: "#1C1C1C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85063 45.1783C2.79981 45.3346 2.76931 45.5641 2.92687 45.7643C3.18607 46.1012 5.56465 46.8093 5.56465 46.8093C6.05256 46.9656 6.20504 46.5261 6.25586 46.1794L2.85063 45.1734V45.1783Z",
    fill: "url(#paint8_linear_26643_10012)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27767 45.8037L2.92835 45.0028C2.92835 45.0028 2.88769 45.0712 2.85212 45.1786L6.25734 46.1846C6.28784 45.9795 6.27767 45.8086 6.27767 45.8086V45.8037Z",
    fill: "#1C1C1C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29036 32.2537L5.29036 34.7539C5.29036 34.9199 5.43267 35.0566 5.60547 35.0566L5.60547 31.951C5.43267 31.951 5.29036 32.0877 5.29036 32.2537Z",
    fill: "#592300"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13411 19.7322L5.13411 22.2324C5.13411 22.3984 5.27642 22.5352 5.44922 22.5352L5.44922 19.4295C5.27642 19.4295 5.13411 19.5662 5.13411 19.7322Z",
    fill: "#592300"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7188 32.2532C34.7188 32.0872 34.5764 31.9505 34.4036 31.9505V35.0562C34.5764 35.0562 34.7188 34.9194 34.7188 34.7534V32.2532Z",
    fill: "#592300"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M34.877 19.7322C34.877 19.5662 34.7346 19.4295 34.5618 19.4295V22.5352C34.7346 22.5352 34.877 22.3984 34.877 22.2324V19.7322Z",
    fill: "#592300"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4277 53.1577C13.9245 53.1186 13.6704 52.8452 13.1621 52.8061C13.1215 52.8061 13.0859 52.8354 13.0859 52.8745C13.0859 52.9135 13.1215 52.9477 13.1621 52.9477C13.6653 52.9868 13.9194 53.2603 14.4277 53.2993C14.4683 53.2993 14.5039 53.27 14.5039 53.231C14.5039 53.1919 14.4683 53.1626 14.4277 53.1577Z",
    fill: "#555555"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4269 52.8701C13.9237 52.831 13.6696 52.5576 13.1614 52.5185C13.1207 52.5185 13.0851 52.5478 13.0851 52.5869C13.0851 52.6259 13.1207 52.6601 13.1614 52.6601C13.6645 52.6992 13.9186 52.9727 14.4218 53.0117C14.4625 53.0117 14.498 52.9824 14.498 52.9434C14.498 52.9043 14.4625 52.8701 14.4218 52.8701H14.4269Z",
    fill: "#555555"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4269 52.5859C13.9237 52.5469 13.6696 52.2734 13.1614 52.2343C13.1207 52.2343 13.0851 52.2636 13.0851 52.3027C13.0851 52.3418 13.1207 52.376 13.1614 52.376C13.6645 52.415 13.9186 52.6885 14.4218 52.7275C14.4625 52.7275 14.498 52.6982 14.498 52.6592C14.498 52.6201 14.4625 52.5859 14.4218 52.5859H14.4269Z",
    fill: "#555555"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8339 52.8071C26.3308 52.8462 26.0766 53.1196 25.5684 53.1587C25.5277 53.1587 25.4922 53.1929 25.4922 53.2319C25.4922 53.271 25.5277 53.3052 25.5684 53.3003C26.0716 53.2612 26.3257 52.9878 26.8339 52.9487C26.8746 52.9487 26.9102 52.9145 26.9102 52.8755C26.9102 52.8364 26.8746 52.8022 26.8339 52.8071Z",
    fill: "#555555"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8339 52.52C26.3308 52.5591 26.0766 52.8325 25.5735 52.8716C25.5328 52.8716 25.4972 52.9058 25.4972 52.9448C25.4972 52.9839 25.5328 53.0181 25.5735 53.0132C26.0766 52.9741 26.3308 52.7007 26.8339 52.6616C26.8746 52.6616 26.9102 52.6274 26.9102 52.5884C26.9102 52.5493 26.8746 52.5151 26.8339 52.52Z",
    fill: "#555555"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8331 52.2353C26.33 52.2744 26.0759 52.5479 25.5676 52.5869C25.527 52.5869 25.4914 52.6211 25.4914 52.6602C25.4914 52.6992 25.527 52.7334 25.5676 52.7285C26.0708 52.6895 26.3249 52.416 26.8281 52.3769C26.8687 52.3769 26.9043 52.3428 26.9043 52.3037C26.9043 52.2646 26.8687 52.2305 26.8281 52.2353H26.8331Z",
    fill: "#555555"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0039 2.56783C20.0039 2.56783 17.8997 2.53365 15.3382 2.7534C15.4653 2.92431 15.6736 3.03662 15.9125 3.03662L24.08 3.03662C24.3189 3.03662 24.5272 2.92431 24.6543 2.74852C22.0978 2.52877 19.9988 2.56295 19.9988 2.56295L20.0039 2.56783Z",
    fill: "url(#paint9_linear_26643_10012)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M29.5101 9.97029C29.5101 9.97029 27.5737 9.07179 24.8089 8.54929C22.6794 8.14399 17.3326 8.14399 15.2031 8.54929C14.2425 8.72997 13.3836 8.95948 12.667 9.17922C13.0431 10.107 14.6593 13.7206 17.3225 14.873C18.1611 14.8193 19.0556 14.79 20.006 14.79C24.6513 14.79 27.6957 15.3759 29.3272 15.8105C29.7846 12.6951 29.5101 9.97517 29.5101 9.97517V9.97029Z",
    fill: "url(#paint10_linear_26643_10012)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_26643_10012",
    x: 4.07227,
    y: 1.69238,
    width: 34.5723,
    height: 66.6152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_26643_10012"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_26643_10012",
    x: 7.53437,
    y: 2.8415,
    width: 5.56406,
    height: 2.05527,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_26643_10012"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_26643_10012",
    x: 26.2746,
    y: 2.74971,
    width: 5.86875,
    height: 2.14805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect1_foregroundBlur_26643_10012"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_26643_10012",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(26.0193 24.9991 -26.0193 24.9991 19.9454 33.9698)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_26643_10012",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(26.3355 25.303 -26.3355 25.303 20.0094 34.3483)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0F0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26643_10012",
    x1: 12.0701,
    y1: 37.0107,
    x2: 27.3094,
    y2: 52.8719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26643_10012",
    x1: 12.9836,
    y1: 6.00419,
    x2: 26.4703,
    y2: 20.0412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C1C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_26643_10012",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.69269 1.62632 -1.69269 1.62632 9.65229 64.347)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_26643_10012",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.69269 1.62632 -1.69269 1.62632 30.3597 64.347)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26643_10012",
    x1: 22.1756,
    y1: 16.7692,
    x2: 21.0802,
    y2: 39.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2C2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26643_10012",
    x1: 34.7731,
    y1: 45.1503,
    x2: 36.1531,
    y2: 46.5867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#929C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_26643_10012",
    x1: 3.30802,
    y1: 44.7386,
    x2: 5.62652,
    y2: 47.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_26643_10012",
    x1: 17.669,
    y1: 0.520487,
    x2: 22.1473,
    y2: 5.18154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00163B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_26643_10012",
    x1: 22.9217,
    y1: 3.72093,
    x2: 21.6402,
    y2: 10.0639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00163B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/Car.9b4c09d971a45c542627327d6a22fbc1.svg";
export { ForwardRef as ReactComponent };